import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";
import { OrganizationType } from "../components/main/body/screens/IAM/Users/types/OrganizationType";


type singleMedical = {
    Id: string;

    tailNumber: number;
 
    
}
interface Items {
    id?: string,
    name?: string
}

interface Items2 {
    id: string,
    name: string
}

export class MedicalKitStore {

    historySearchString = [];
    flights=[];
    // SpecificFlights:singleFlight | null = null;
    Id: string="";
    msn : number | null = null;
    TailNumber: number | null = null;
    FleetType : string="";
    WifiProvider : string="";
    EditFlightOrgList: OrganizationType[] = [];
    Org : string = "";
    update : number = 0;
    AddOrg : string = '';
    orgid : string="";
    updates : number = 0;
    expiry:string='';
    FlightNo:string='';
    items:Items[] = [];
    Item:any =[];
    isMedicalKit : boolean = false;
    medicalKitScanNotifyTime: string | null = null;
    Date: string = new Date().toISOString();
    flightTailNo: string = "";
    medicalKitDetail: any = [];
    updatess : number = 0;
    kitSelectedItem: Items2[] = [];
    medicalKitId: string = "";


    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    // handleflightlist(list : any){
    //     this.historySearchString = list;
    // }

    // get getFlightlist(){
    //    return this.historySearchString;
    // }
    // handleSpecificFlights(list : any){
    //     this.SpecificFlights= list;
    // }
    handlemedicallist(list : any){
        this.historySearchString = list;
    }

    get getmedicallist(){
       return this.historySearchString;
    }
    handleupdate = () => {
        this.updates++;
    }
    get getupdate () {
        return this.updates ;
    }
    handleExpiry = (date: string) => {
        this.expiry = date;
    }
    get getExpiry () {
        return this.expiry ;
    }
    handleFlightNo = (flightno: string) => {
        this.FlightNo = flightno;
    }
    get getFlightNo() {
        return this.FlightNo ;
    }

    setItems = (id?: string,name?: string) => {
        if ( id!=undefined && id != "" ) {
            let obj = { id: id }
            const exists = this.items.some(item => item.id === obj.id);
            if (!exists) {
                this.items.push(obj)
            } else {
                const filterArray = this.items.filter(item => item.id != obj.id);
                this.items = filterArray;
            }
        } 
        else if (name!=undefined) {
            let obj2 = { name: name }
            const exists = this.items.some(item => item.name === obj2.name);
            if (!exists) {
                this.items.push(obj2);
            } else {
                const filterArray = this.items.filter(item => item.name != obj2.name);
                this.items = filterArray;
            }
        }
    }
    get getItems() {
        return this.items;
    }
    resetItems = () => {
        this.items = [];
    }
    handleDate=(date: string)=>{
        const a = new Date(date);
        const ISOString = a.toISOString();
        this.Date= ISOString;
    }

    get getDate(){ 
       return this.Date;
    }
    handleItem=(item: any)=>{
        if (Array.isArray(item)) {
            this.medicalKitDetail= item;
        } else if (typeof item === 'object' && item !== null) {
            this.medicalKitDetail.push(item);
        } else {}
    }

    get getItem(){ 
       return this.medicalKitDetail;
    }

    handleFlightTailNo = (tailno: string) => {
        this.flightTailNo = tailno;
    }
    get getFlightTailNo() {
        return this.flightTailNo;
    }

    handleupdates = () => {
        this.updates++;
    }
    get getupdates () {
        return this.updates ;
    }

    handleKitSelectedItem = (item: Items2) => {
        if (this.kitSelectedItem.map((kit) => kit.id).includes(item.id)) {
            this.kitSelectedItem = this.kitSelectedItem.filter((storedItem) => storedItem.id !== item.id)
        } else {
            this.kitSelectedItem.push(item);
        }
    }
    get getKitSelectedItem() {
        return this.kitSelectedItem;
    }
    resetKitSelectedItem = () => {
        this.kitSelectedItem = [];
    }
  
    handleMedicalKitId = (id: string) => {
        this.medicalKitId = id;
    }
    get getMedicalKitId() {
        return this.medicalKitId;
    }
    resetMedicalKitId = () => {
        this.medicalKitId = '';
    }
    handleIsMedicalKit = (pageScan : boolean) => {
        this.isMedicalKit = pageScan;
    }
    get getIsMedicalKit () {
        return this.isMedicalKit ;
    }

    setMedicalKitNotifyTime = (time: string | null) => {
        this.medicalKitScanNotifyTime = time;
    }
    get getMedicalKitNotifyTime() {
        return this.medicalKitScanNotifyTime;
    }
    
}

 